import { Fragment, useCallback, useEffect, useRef } from "react";
import { ITabulatorProps, TabulatorFilterParam } from "./types";
import { useTabulator } from "./useTabulator";
import "./tabulator_simple.scss";

export const ReactTabulator = (props: ITabulatorProps) => {
	const { create, destroy, setData, setColumns, setHeight, download } = useTabulator();
	const element = useRef<any>(null);

	//useEffect(() => {
	//	setFilter(props.dataFilter as TabulatorFilterParam);
	//}, [props.dataFilter, setFilter]);

	useEffect(() => {
		// Create must run first so the table instance exists before other effects call setHeight/setColumns/setData.
		create(element.current, props);
		return () => {
			destroy();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setHeight(props.options.height);
	}, [props.options.height, setHeight]);

	useEffect(() => {
		setColumns(props.options.columns);
	}, [props.options.columns, setColumns]);

	useEffect(() => {
		setData(props.data || [], props.options.ajaxParams);
	}, [props.data, props.options.ajaxParams, setData]);

	const downloadData = useCallback(() => {
		const downloadInfo = props.download;
		if (download && downloadInfo) {
			download("xlsx", downloadInfo.fileName || "data.xlsx", { sheetName: downloadInfo.sheetName || "Data" }, downloadInfo.rowRange);
		}
	}, [download, props.download]);

	if (props.download) {
		return (
			<Fragment>
				<div style={{ alignContent: "right", width: "100%" }}>
					<a href="#" onClick={downloadData}>{props.download.buttonLabel || "Download XLSX"}</a>
				</div>
				<div ref={element} />
			</Fragment>
		);
	}
	else
		return <div ref={element} />;
};